<template>
	<div class="container pb-10">
		<div class="flex justify-between items-center py-2 mb-4">
			<h1 class="page-title">Contracte Productie RO</h1>
		</div>

		<div class="light-grey rounded mb-4 p-4">
			<div class="flex flex-col lg:flex-row lg:justify-between lg:items-center gap-2 lg:gap-10 w-full">
				<div class="w-full lg:w-1/2 flex flex-row items-center gap-2">
					<!-- <v-text-field v-model="filterInput" clearable flat solo hide-details
						prepend-inner-icon="mdi-magnify" label="Cauta contract dupa client"></v-text-field> -->
					<v-text-field v-model="searchClient" clearable flat solo hide-details
						@keydown.enter="searchContracts" @click:clear="resetInitialContracts"
						prepend-inner-icon="mdi-magnify" label="Cauta contract dupa client">
					</v-text-field>
					<v-btn color="blue-grey" class="uppercase" large dark @click="searchContracts">Cauta</v-btn>
				</div>
				<div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 w-full lg:w-auto">
					<v-select ref="selectAgent" v-model="filterAgent" class="w-full sm:w-60" :items="agents"
						item-text="username" item-value="id_user" :clearable="true"
						:class="{ 'opacity-60': isContractsSearchList }" @click:clear="$refs.selectAgent.blur()"
						label="Intocmit de" solo hide-details></v-select>
					<div class="w-full sm:w-60">
						<v-menu v-model="monthpickerMenu" class="w-full" :close-on-content-click="false" left
							transition="scale-transition" offset-y min-width="auto">
							<template v-slot:activator="{ on, attrs }">
								<v-text-field v-model="monthText" class="date-field"
									:class="{ 'opacity-60': isContractsSearchList }" label="Luna" solo
									prepend-inner-icon="mdi-calendar" hide-details readonly v-bind="attrs"
									v-on="on"></v-text-field>
							</template>
							<v-date-picker v-model="selectedMonth" no-title type="month"
								@input="changeMonth"></v-date-picker>
						</v-menu>
					</div>
				</div>
			</div>
		</div>

		<v-sheet class="p-4 rounded mb-1 flex flex-row flex-wrap justify-start lg:justify-end gap-6 lg:gap-20">
			<div>
				<v-label>Nr. contracte</v-label>
				<p class="text-xl text-black font-bold mb-0">{{ userContracts.length }}</p>
			</div>
			<div>
				<v-label>Valoare contracte</v-label>
				<p class="text-xl text-black font-bold mb-0">{{
					$options.filters.formatEur(userContractsTotal.toFixed(2))
				}}
					<span class="text-sm text-gray-600 font-normal">(TVA inclus)</span>
				</p>
			</div>
			<div>
				<v-label class="text-sm font-bold">* cifre per luna</v-label>
			</div>
		</v-sheet>

		<v-data-table :headers="headers" :items="filterBy(contracts, filterInput, selectedUser)" item-key="id_contract"
			:loading="loadingContracts" :items-per-page="-1" hide-default-footer>
			<template v-slot:item.dateContract="{ item }">
				{{ item.data | formatDate }}
			</template>
			<template v-slot:item.detailsAddress="{ item }">
				{{ item.detalii.adresa }}
			</template>
			<template v-slot:item.detailsLocation="{ item }">
				{{ item.detalii.alta_locatie ? item.detalii.locatie : 'idem' }}
			</template>
			<template v-slot:item.additional="{ item }">
				<v-tooltip top>
					<template v-slot:activator="{ on, attrs }">
						<v-icon v-if="item.id_aditional" color="blue" dark v-bind="attrs" v-on="on">
							mdi-file-document-plus
						</v-icon>
					</template>
					<span>Act aditional</span>
				</v-tooltip>
			</template>
			<template v-slot:item.status_contract="{ item }">
				<v-tooltip top>
					<template v-slot:activator="{ on, attrs }">
						<v-btn icon text @click="openStatusConfirm(item)" v-bind="attrs" v-on="on">
							<v-icon :color="item.status_contract === 'completed' ? 'green' : 'grey lighten-1'">
								{{ item.status_contract === 'completed' ? 'mdi-check-circle' : 'mdi-circle-outline' }}
							</v-icon>
						</v-btn>
					</template>
					<span>{{ item.status_contract === 'completed' ? 'Finalizat' : 'Marcheaza ca finalizat' }}</span>
				</v-tooltip>
			</template>
			<template v-slot:item.reviews="{ item }">
				<v-btn icon text @click="openReviewModal(item)">
					<v-icon :color="reviewColor(item.status_review)" dark>
						mdi-message-star
					</v-icon>
				</v-btn>
			</template>
			<template v-slot:item.actions="{ item }">
				<v-btn text rounded color="primary"
					:to="'/productie/contracte/single/' + item.id_contract">detalii</v-btn>
			</template>
		</v-data-table>

		<v-dialog v-model="visibleStatusConfirm" max-width="420px">
			<v-card>
				<v-card-title class="text-h6">
					{{ pendingStatusContract && pendingStatusContract.status_contract === 'completed' ?
						"Anuleaza finalizarea ? "
						: "Marchează ca finalizat ? " }}
				</v-card-title>
				<v-card-text v-if="pendingStatusContract">
					{{ pendingStatusContract.nume }}
				</v-card-text>
				<div class="flex flex-row justify-end gap-2 p-4">
					<v-btn color="white-text blue-grey" class="uppercase" large
						@click="visibleStatusConfirm = false">Anuleaza</v-btn>
					<v-btn color="teal" dark class="uppercase" large @click="confirmStatusChange">Confirma</v-btn>
				</div>
			</v-card>
		</v-dialog>

		<v-dialog v-model="visibleReviewModal" max-width="600px">
			<v-card>
				<v-form ref="reviewForm" v-model="validReviewForm" @submit.prevent="setReviewState">
					<v-card-title>
						<span class="text-h5">Schimba statusul recenziei</span>
					</v-card-title>
					<v-card-text>
						<v-select v-model="newReview.status_review" class="w-2/3" :items="reviewStatusList"
							item-text="text" item-value="value" label="Status recenzie" outlined></v-select>
						<v-textarea v-if="newReview.status_review === 'clientul nu accepta'"
							v-model="newReview.status_review_obs" label="Observații" outlined></v-textarea>
					</v-card-text>
					<div class="flex flex-row justify-end gap-2 p-4">
						<v-btn color="blue-grey" class="uppercase white-text" large
							@click="closeReviewModal">Anuleaza</v-btn>
						<v-btn color="teal" dark class="uppercase" large type="submit">Salveaza</v-btn>
					</div>
				</v-form>
			</v-card>
		</v-dialog>

		<div v-if="$isDev">
			<!-- <pre>{{ contracts }}</pre> -->
		</div>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { escapeRegExp, onlyUnique, containsObjectValue, fenceValueWithVat, otherValueWithVat } from '@/utils';

export default {
	name: "ContracteProductieRO",
	components: {},
	data() {
		return {
			filterInput: "",
			searchClient: null,
			monthpickerMenu: false,
			selectedMonth: new Date().toISOString().substring(0, 7),
			selectedUser: null,
			delID: "",
			headers: [
				{
					text: 'Nr.',
					align: 'start',
					sortable: false,
					value: 'id_contract'
				},
				{
					text: 'Data contract',
					align: 'start',
					sortable: false,
					value: 'dateContract',
				},
				{
					text: 'Client',
					align: 'start',
					sortable: false,
					value: 'nume',
				},
				{
					text: 'Oferta',
					align: 'start',
					sortable: false,
					value: 'oferta_id',
				},
				{
					text: 'Adresa facturare',
					align: 'left',
					sortable: false,
					value: 'detailsAddress',
				},
				{
					text: 'Adresa montaj',
					align: 'left',
					sortable: false,
					value: 'detailsLocation',
				},
				{
					text: 'Proforma platită',
					align: 'start',
					sortable: false,
					value: 'paid_status',
				},
				{
					text: 'Intocmit de',
					align: 'start',
					sortable: false,
					value: 'username',
				},
				{
					text: 'Act aditional',
					value: 'additional',
					align: 'center',
					sortable: false,
					width: '5%'
				},
				{
					text: 'Finalizat',
					value: 'status_contract',
					align: 'center',
					sortable: false,
					width: '5%'
				},
				{
					text: 'Recenzii',
					value: 'reviews',
					align: 'center',
					sortable: false,
					width: '5%'
				},
				{
					value: 'actions',
					sortable: false,
					width: '5%'
				}
			],
			selectedOffer: null,
			selectedContract: null,
			// answerList: [
			// 	"Nu doreste, considera ca este scump",
			// 	"Are deja garaj",
			// 	"Are deja carport",
			// 	"Este interesat",
			// ],
			// carport: {
			// 	selectedAnswer: "",
			// 	selectedCarportPrice: "",
			// },
			visibleStatusConfirm: false,
			pendingStatusContract: null,
			visibleReviewModal: false,
			validReviewForm: false,
			newReview: {},
		};
	},
	computed: {
		...mapState('contracts', [
			'contracts',
			'loadingContracts',
			'isContractsSearchList'
		]),
		user() {
			return this.$store.getters.loggedUser;
		},
		reviewStatusList() {
			const list = [
				// { text: 'S-a solicitat', value: 's-a solicitat' },
				{ text: 'Cadou trimis către client', value: 'cadou trimis' },
				{ text: 'Client accepta sa trimita recenzia', value: 'clientul accepta' },
				{ text: 'Clientul nu accepta', value: 'clientul nu accepta' },
				{ text: 'Clientul a trimis recenzia', value: 'recenzie activa' },
				{ text: 'Nu s-a solicitat', value: 'nu s-a solicitat' },
			];
			if (['admin', 'superuser'].includes(this.user.rol)) return list;
			return list.filter(item => item.value !== 'recenzie activa');
		},
		monthText() {
			return this.$options.filters.formatMonth(this.selectedMonth)
		},
		firstDay() {
			return new Date(this.selectedMonth).toISOString().split('T')[0]
		},
		lastDay() {
			return new Date(new Date(this.selectedMonth).getFullYear(), new Date(this.selectedMonth).getMonth() + 1, 1).toISOString().split('T')[0]
		},
		filterAgent: {
			get() {
				return this.selectedUser
			},
			// setter
			set(newValue) {
				this.selectedUser = newValue
			},
		},
		agents() {
			let array = [];
			let user = {};

			this.contracts.forEach((contract) => {
				user = {
					id_user: contract.id_user,
					username: contract.username,
				};
				if (containsObjectValue(user, array, 'id_user')) {
					return;
				} else {
					array.push(user);
				}
			});
			return array.filter(onlyUnique);
		},
		userContracts() {
			if (this.selectedUser) {
				return this.contracts.filter((contract) => this.selectedUser == contract.id_user);
			} else {
				return this.contracts
			}
		},
		userContractsTotal() {
			let sum = 0
			this.userContracts.forEach(contract => {
				let s = fenceValueWithVat(contract) + otherValueWithVat(contract)
				sum += s
			})
			return sum
		}
	},
	watch: {
		'newReview.status_review'(newVal) {
			if (newVal != 'clientul nu accepta') {
				this.newReview.status_review_obs = null
			}
		},
		isContractsSearchList(newVal) {
			if (newVal) {
				this.selectedUser = null
			} else {
				if (['admin', 'superuser'].includes(this.user.rol)) {
					return
				}
				this.selectedUser = this.user.id_user
			}
		}
	},
	methods: {
		...mapActions('contracts', [
			'fetchContractsManufacturing',
			'fetchContractsManufacturingBySearchTerm',
			'updateContractReviewStatus',
			'updateContractStatus',
		]),
		reviewColor(reviewStatus) {
			switch (reviewStatus) {
				case 'nu s-a solicitat':
					return 'grey'
				case 's-a solicitat':
					return 'lime'
				case 'cadou trimis':
					return 'purple'
				case 'recenzie activa':
					return 'green';
				case 'clientul accepta':
					return 'blue';
				case 'clientul nu accepta':
					return 'red';
				default:
					return 'grey'
			}
		},
		changeMonth() {
			this.monthpickerMenu = false
			this.fetchContracteProductie()
		},
		filterBy(list, value, agent) {
			if (!value) {
				value = ""
			}
			const words = value
				.split(/\s+/g)
				.map((s) => s.trim())
				.filter((s) => !!s);

			const hasTrailingSpace = value.endsWith(" ");

			const searchRegex = new RegExp(
				words
					.map((word, i) => {
						if (i + 1 === words.length && !hasTrailingSpace) {
							// The last word - ok with the word being "startswith"-like
							return `(?=.*\\b${escapeRegExp(word)})`;
						} else {
							// Not the last word - expect the whole word exactly
							return `(?=.*\\b${escapeRegExp(word)}\\b)`;
						}
					})
					.join("") + ".+",
				"i"
			);

			// See if current user has contracts
			let userContracte = this.agents.find((item) => {
				return item.id_user == agent;
			});
			return list.filter((contract) => {
				if (userContracte == undefined || this.isContractsSearchList) {
					return searchRegex.test(contract.nume);
				} else {
					return (
						searchRegex.test(contract.nume) &&
						contract.id_user == agent
					);
				}
			});
		},
		async fetchContracteProductie() {
			await this.fetchContractsManufacturing({
				country: 'ro',
				date1: this.firstDay,
				date2: this.lastDay,
			});
			this.searchClient = null
		},
		resetInitialContracts() {
			this.fetchContracteProductie();
		},
		searchContracts() {
			this.fetchContractsManufacturingBySearchTerm({ country: 'ro', searchTerm: this.searchClient })
			// this.$store.dispatch("fetchContracteProductieBySearchTerm", this.searchClient)
		},
		// replaceSpecialCh(str) {
		// 	return str
		// 		.replace(/ș|Ș/g, "s")
		// 		.replace(/ț|Ț/g, "t")
		// 		.replace(/î|Î/g, "i")
		// 		.replace(/ă|â|Â|Ă/g, "a");
		// },
		// denumireModulGard(str, tip_poarta) {
		// 	if (str == "Panou") {
		// 		str += " gard";
		// 	}
		// 	if (str == "Poarta_mica") {
		// 		str += "_pietonala";
		// 	}
		// 	if (str == "Poarta_mare") {
		// 		str += `_${tip_poarta}`;
		// 	}
		// 	let newStr = str.replace(/_/g, " ");
		// 	return newStr;
		// },
		// openCarportModal(contract) {
		// 	this.selectedContract = contract.id_contract;
		// 	this.selectedOffer = contract.oferta_id;
		// 	const instance = M.Modal.getInstance(
		// 		document.querySelector(".modal-carport")
		// 	);
		// 	instance.open();
		// },
		// saveCarportAnswer() {
		// 	this.$store.dispatch("saveCarportInfoOffer", {
		// 		contract_id: this.selectedContract,
		// 		offer_id: this.selectedOffer,
		// 		carport: { ...this.carport },
		// 	});
		// 	M.Modal.getInstance(document.querySelector(".modal-carport")).close();
		// 	this.carport = {
		// 		selectedAnswer: "",
		// 		selectedCarportPrice: "",
		// 	}
		// },

		openStatusConfirm(item) {
			this.pendingStatusContract = item;
			this.visibleStatusConfirm = true;
		},
		confirmStatusChange() {
			const newStatus = this.pendingStatusContract.status_contract === 'completed' ? null : 'completed';
			this.updateContractStatus({ id: this.pendingStatusContract.id_contract, status_contract: newStatus });
			this.visibleStatusConfirm = false;
			this.pendingStatusContract = null;
		},
		openReviewModal(item) {
			if (this.user.rol !== 'admin' && item.status_review == 'recenzie activa') {
				return
			}
			this.newReview = Object.assign({}, { id: item.id_contract, status_review: item.status_review, status_review_obs: item.status_review_obs, client_name: item.nume });
			this.visibleReviewModal = true;
		},
		setReviewState() {
			this.updateContractReviewStatus({ ...this.newReview, username: this.user.username })
			this.closeReviewModal();
		},
		closeReviewModal() {
			this.visibleReviewModal = false
			this.$nextTick(() => {
				this.newReview = Object.assign({}, {})
			})
		},
	},
	async created() {
		await this.fetchContracteProductie();
	},
	mounted() {
		if (!['admin', 'superuser'].includes(this.user.rol)) {
			this.selectedUser = this.user.id_user
		}
		M.Modal.init(document.querySelectorAll(".modal"));
	},
	updated: function () {
		M.FormSelect.init(document.querySelectorAll("select"));
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.carport-icon {
	color: blue;
}

.delete-icon:hover {
	color: red !important;
}
</style>

<style scoped>
::v-deep .v-data-table__mobile-table-row {
	display: block !important;
	margin-bottom: 12px;
}
</style>
